import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Consumos from '../pages/consumos/Consumos';
import ProtectedRoute from './ProtectedRoute';
import Login from '../pages/login/Login';
import { useAuth } from '../hooks/useAuth';
import PublicRoute from './PublicRoute';
import Autorizacion from "../pages/autorizacion/Autorizacion";
import Reglas from '../pages/reglas/Reglas';
import VistaReglas from '../pages/vistaReglas/VistaReglas';
import Transacciones from '../pages/transacciones/Transacciones';

function AppRoutes() {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return <p>Cargando...</p>;
    }

    return (
        <Router>
            <Routes>
                <Route path="/login" element={<PublicRoute element={<Login />} />} />
                <Route path="/home" element={<ProtectedRoute element={<Consumos />} />} />
                <Route path="/autorization" element={<ProtectedRoute element={<Autorizacion />} />} />
                <Route path="/rules" element={<ProtectedRoute element={<Reglas />} />} />
                <Route path="/rulesView" element={<ProtectedRoute element={<VistaReglas />} />} />
                <Route path="/transactions" element={<ProtectedRoute element={<Transacciones />} />} />
                <Route
                    path="/"
                    element={
                        isAuthenticated ? <Navigate to="/rulesView" replace /> : <Navigate to="/login" replace />
                    }
                />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
}

export default AppRoutes;
